<script setup>
    defineProps({
        cars: Array,
        columns: {
            type: Number,
            default: 4,
        },
    })
</script>

<template>
    <div class="cars-container container">
        <div
            class="grid-rows-auto mb-[9.5rem] grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4"
        >
            <p v-if="cars.length === 0" class="text-brand2">
                Sorry, no cars within your selected budget.
            </p>

            <TransitionGroup name="cars" v-else>
                <template v-for="car in cars" :key="car.id">
                    <CarItem
                        :car="car"
                        class="car-item cursor-pointer transition"
                    />
                </template>
            </TransitionGroup>
        </div>
    </div>
</template>

<style>
    .container .cars-container {
        padding-inline: 0;
    }

    .cars-container > div {
        --gap: 1rem;
        --columns: v-bind(columns);
        gap: var(--gap);

        @screen lg {
            --gap: 1.5rem;
        }

        .cars-move,
        .cars-enter-active,
        .cars-leave-active {
            transition: all 0.5s ease;
        }

        .cars-enter-from,
        .cars-leave-to {
            opacity: 0;
            transform: translateX(30px);
        }

        .cars-leave-active {
            position: absolute;
            width: calc(
                (100% - var(--gap) * (var(--columns) - 1)) / var(--columns)
            );
        }
    }

    .car-item {
        /* --width: 83.33vw;
        min-width: var(--width); */

        /* &:not(:first-child) {
            min-width: calc(var(--width) + var(--padding));
        } */

        /* @screen sm {
            &,
            &:not(:first-child) {
                min-width: 0;
                margin-left: 0;
                width: calc(100% / var(--columns) - (var(--gap) * 2));
            }
        } */
    }
</style>
